"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackCard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = __importDefault(require("../../../assets/icons"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var Icon_1 = require("../../atoms/Icon/Icon");
var Link_1 = require("../../atoms/Link/Link");
var Link_logic_1 = require("../../atoms/Link/Link.logic");
var StatusLabel_1 = require("../../atoms/StatusLabel/StatusLabel");
var Typography_1 = require("../../atoms/Typography/Typography");
var StackCard_style_1 = __importDefault(require("./StackCard.style"));
/**
 * StackCard molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-stackcard--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/StackCard Source}
 */
var StackCard = function (_a) {
    var description = _a.description, isSelected = _a.isSelected, onClick = _a.onClick, status = _a.status, _b = _a.statusColor, statusColor = _b === void 0 ? 'gray' : _b, title = _a.title, url = _a.url, urlLabel = _a.urlLabel;
    var classes = (0, StackCard_style_1.default)();
    var isExternalLink = !!url && (0, Link_logic_1.isExternalUrl)(url);
    function onClickLink(event) {
        event.stopPropagation();
    }
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)(classes.root, isSelected && classes.selectedCard), onClick: onClick }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.headContainer }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ overflowEllipsis: true, numberOfLines: 1, bold: true, className: classes.title }, { children: title })), (0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: icons_1.default.chevronRight, color: theme_1.default.colors.dark })] })), renderDescription(), renderLink(), renderStatusLabel()] })));
    function renderDescription() {
        return description && (0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ "data-testid": 'description' }, { children: description }));
    }
    function renderLink() {
        return (url && ((0, jsx_runtime_1.jsx)(Link_1.Link, __assign({ onNavigate: onClickLink, url: url }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.linkContent }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ component: 'span', overflowEllipsis: true, color: theme_1.default.textColors.highlight, hoverVariant: 'dark' }, { children: urlLabel || url })), isExternalLink && ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { color: theme_1.default.colors.primary, iconPath: icons_1.default.newTab, "data-testid": 'newTab-icon' }))] })) }))));
    }
    function renderStatusLabel() {
        return (status && (0, jsx_runtime_1.jsx)(StatusLabel_1.StatusLabel, { status: status, overflowEllipsis: true, statusColor: statusColor, "data-testid": 'statusLabel' }));
    }
};
exports.StackCard = StackCard;
